var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.18 50.52 1.92-16.69a2.82 2.82 0 0 0 -3.1-3.14l-16.65 2a1.53 1.53 0 0 0 -.89 2.61l2.89 2.9c-5.54 5.3-12.44 12.2-27.45 8.2a.37.37 0 0 0 -.33.65c21 15.38 34.68 4.65 38 1.43l3 3a1.57 1.57 0 0 0 2.61-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.6 29.59-2.89-2.9c5.5-5.34 12.4-12.24 27.41-8.24a.37.37 0 0 0 .33-.65c-21-15.38-34.72-4.61-38-1.43l-3-3a1.54 1.54 0 0 0 -2.62.9l-1.91 16.66a2.82 2.82 0 0 0 3.14 3.15l16.69-1.92a1.52 1.52 0 0 0 .85-2.57z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a742aba9.svg";
export { ForwardRef as ReactComponent };